import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 32L0 544l44.8 44.8 467.2-464 467.2 464L1024 544z\" p-id=\"8453\" fill=\"#ffffff\" /><path d=\"M800 928H672V672H352v256H224V576h-64v416h256V736h192v256h256V576h-64z\" p-id=\"8454\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol